//Componentes generales
import React, { useState, useMemo, useContext } from "react";
import { FixedSizeList } from "react-window";
import SearchInput from "../searchInput/SearchInput";
import RenderRow from "../renderRows/RRProviders";
import windowSizeContext from "../../context/windowSize/windowSizeContext";

//Estilos
import "./ProviderList.css";

/*
    Componente encargado de la vista de los proveedores disponibles.
    Donde proveedores es la lista de proveedores disponibles recuperados del context.
*/
function ProviderList({ proveedores = [] }) {
  //state de filtro.
  const [filter, setFilter] = useState("");

  // Calcula el valor del height según el tamaño de la pantalla y el tamaño del navbar
  const wSContext = useContext(windowSizeContext);
  let { height } = wSContext;

  /*
    Manejador ante cambios en filtro.
    Donde data es el texto ingresado por el usuario.
    */
  const handdlerSearchInput = (data) => {
    setFilter(data);
  };

  return (
    <div>
      <div style={{ marginLeft: "-350px" }}>
        <SearchInput defaultValue={filter} buscar={handdlerSearchInput} />
      </div>
      <div className="container-provider-list">
      
        <FixedSizeList
          height={height - 270}
          itemCount={
            filter === ""
              ? proveedores.length
              : proveedores.filter(
                (p) =>
                  p.nroCta.toLowerCase().includes(filter.toLowerCase()) ||
                  p.nombre.toLowerCase().includes(filter.toLowerCase())
              ).length
          }
          itemSize={150}
          width={"100%"}
        >
          {({ index, style }) => (
            <RenderRow
              index={index}
              style={style}
              proveedores={proveedores}
              filter={filter}
            />
          )}
        </FixedSizeList>
      </div>
    </div>
  );
}

export default ProviderList;